<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 26 26">
    <path
      d="M4.3335 21.1251V4.87508C4.3335 4.15679 4.61884 3.46791 5.12675 2.96C5.63466 2.45209 6.32353 2.16675 7.04183 2.16675H20.5835C20.8708 2.16675 21.1464 2.28088 21.3495 2.48405C21.5527 2.68721 21.6668 2.96276 21.6668 3.25008V22.7501C21.6668 23.0374 21.5527 23.3129 21.3495 23.5161C21.1464 23.7193 20.8708 23.8334 20.5835 23.8334H7.04183C6.32353 23.8334 5.63466 23.5481 5.12675 23.0402C4.61884 22.5322 4.3335 21.8434 4.3335 21.1251ZM4.3335 21.1251C4.3335 20.4068 4.61884 19.7179 5.12675 19.21C5.63466 18.7021 6.32353 18.4167 7.04183 18.4167H21.6668"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.6665 11.9167H17.3332"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.6665 7.58325H15.1665"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBook',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: none;
  flex-shrink: 0;
}
</style>
